import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-6">
      <div className="dash-empty-state bg-card border-none shadow-sm max-w-sm w-full">
        <h1 className="mb-2 text-4xl font-bold text-foreground">404</h1>
        <p className="mb-4 text-sm font-medium">Oops! Page not found.</p>
        <a href="/" className="text-primary hover:text-primary/90 text-sm font-bold mt-2 inline-block">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
